import {useState} from 'react';
import {HelpContent} from './HelpContent';
export function HelpKnowledge() {
  const [selected,setSelected]=useState<string|undefined>(),[query,setQuery]=useState('');
  return <section className="knowledge-help" aria-label="Quick guide">
    <label className="help-search">Find an answer<input type="search" value={query} onChange={event=>setQuery(event.target.value)} placeholder="For example: project, animation, download"/></label>
    <HelpContent selected={selected} query={query} choose={id=>{setSelected(id);setQuery('');}} onBack={()=>setSelected(undefined)}/>
  </section>;
}
